// extracted by mini-css-extract-plugin
export var text = "_s-0";